const Select = {
  init(containerId, options, handleSelect, description) {
    this.containerId = containerId;
    this.container = $(`#${this.containerId}`);
    this.options = options;
    this.handleSelect = handleSelect;
    this.description = description;
    return this;
  },

  render() {
    const $select = this._renderSelect();
    $select.on('change', this.handleSelect);
  },

  _renderSelect() {
    const $selectContainer = this.container.find('.chart-options').length ? this.container.find('.chart-options') : $('<div>').addClass('chart-options').appendTo(this.container);

    const baseElement = $('<div>').addClass('chart-group');
    baseElement.appendTo($selectContainer);

    const description = I18n.t(`projects.index.selects.${this.description}`);
    $('<div>').addClass('breakdown-chart-select-description').text(description).appendTo(baseElement);

    const $select = $('<select>').addClass('breakdown-chart-select');
    $select.appendTo(baseElement);

    for (let option of this.options) {
      const optionText = option === '' ? 'Select' : I18n.t(`projects.index.headers.${option}`);
      $("<option>").attr({ value: option }).text(optionText).appendTo($select);
    }
    return $select;
  }
};

export default Select;